import React, { useState, useEffect } from "react"
import queryString from "query-string"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import PropTypes from "prop-types"
import { useBuildData } from "../hooks/use-build-data"
import { newslettersConfirmation } from "../constants"
import { newsletterConfirmContainer } from "../styles/newsletter.module.scss"
import { NewsletterImageComponent } from "../styled-components/newsletter-image-styled"

const NewsletterPage = (props) => {
  const buildInfos = useBuildData().site_settings
  const [subscribedNewsletter, setSubscribedNewsletter] = useState([])
  const [unsubscribedNewsletter, setUnsubscribedNewsletter] = useState([])
  const [error, setError] = useState("")
  const params = queryString.parse(props.location.search)
  useEffect(() => {
    if (!params.newsletter_id) return

    fetch(
      process.env.GATSBYSIDE_DRUPAL_URL +
        "/" +
        newslettersConfirmation +
        "/" +
        params.action +
        "/" +
        params.snid +
        "/" +
        params.newsletter_id +
        "/" +
        params.timestamp +
        "/" +
        params.hash +
        "/gatsby"
    )
      .then((response) => {
        return response.json()
      })
      .then((resultData) => {
        setSubscribedNewsletter(resultData.subscribedNewsletter)
        setUnsubscribedNewsletter(resultData.unsubscribedNewsletter)
        setError(resultData.error)
      })
  }, [params])

  const RenderMessage = () => {
    if (
      !subscribedNewsletter.length &&
      !unsubscribedNewsletter.length &&
      !error
    )
      return null
    if (error) {
      return <p>{error}</p>
    }
    if (subscribedNewsletter.length === 1) {
      return (
        <div className={newsletterConfirmContainer}>
          <h2>
            Vous êtes désormais abonné(e) à la newsletter{" "}
            {subscribedNewsletter[0]}
          </h2>
          <NewsletterImageComponent />
        </div>
      )
    } else if (subscribedNewsletter.length > 1) {
      const newslettersList = []
      for (const index in subscribedNewsletter) {
        newslettersList.push(<li>{subscribedNewsletter[index]}</li>)
      }

      return (
        <div className={newsletterConfirmContainer}>
          <div>
            Vous êtes désormais abonné(e) aux newsletter suivantes :{" "}
            {newslettersList}
          </div>
          <NewsletterImageComponent />
        </div>
      )
    }
    if (unsubscribedNewsletter.length === 1) {
      return (
        <div className={newsletterConfirmContainer}>
          <h2>
            Vous êtes désormais désabonné(e) de la newsletter{" "}
            {subscribedNewsletter[0]}
          </h2>
          <NewsletterImageComponent />
        </div>
      )
    } else if (unsubscribedNewsletter.length > 1) {
      const newslettersList = []
      for (const index in unsubscribedNewsletter) {
        newslettersList.push(<li>{unsubscribedNewsletter[index]}</li>)
      }

      return (
        <div className={newsletterConfirmContainer}>
          <div>
            Vous êtes désormais désabonné(e) aux newsletter suivantes :{" "}
            {newslettersList}
          </div>
          <NewsletterImageComponent />
        </div>
      )
    }
  }

  return (
    <Layout isIndex={true} message={buildInfos.website_name}>
      <SEO title="Confirmation Newsletter" />
      <div
        style={{
          padding: "2.25rem 15% 1rem 15%;",
        }}
      >
        {RenderMessage()}
      </div>
    </Layout>
  )
}

//-----------------------Prop-Types---------------------------//

NewsletterPage.propTypes = {
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default NewsletterPage
